/**
 * 密码强度条。评分逻辑来自 shared 的 passwordStrengthScore（单一事实来源），
 * 这里只负责展示，不重新实现任何强度算法。
 */
import { passwordStrengthScore } from '@fht/shared';
import { cn } from '../../lib/utils';

const LABELS = ['太弱', '较弱', '一般', '较强', '很强'] as const;
const COLORS = [
  'bg-rose-500',
  'bg-orange-500',
  'bg-amber-500',
  'bg-lime-500',
  'bg-emerald-500',
] as const;

export function PasswordStrengthMeter({ password }: { password: string }) {
  const score = passwordStrengthScore(password);
  const label = LABELS[score] ?? LABELS[0];
  const color = COLORS[score] ?? COLORS[0];

  return (
    <div className="space-y-1" aria-live="polite">
      <div className="flex gap-1" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={cn(
              'h-1.5 flex-1 rounded-full transition-colors',
              i < score ? color : 'bg-slate-200',
            )}
          />
        ))}
      </div>
      <p className="text-xs text-slate-500">
        密码强度：<span className="font-medium text-slate-700">{password ? label : '未填写'}</span>
      </p>
    </div>
  );
}
